import React from "react";
import { Box, Card, CardContent, Chip, Typography } from "@mui/material";

// A page that is on the menu before it is built (044: the drawer landed first, the
// pages come one at a time). Props: caption (the section), title, and what the page
// will do, in one sentence from the spec.
export default function Placeholder({ caption, title, description }) {
  return (
    <Box sx={{ flexGrow: 1 }}>
      <Box sx={{ mb: 3 }}>
        <Typography variant="body2" color="text.secondary">
          {caption}
        </Typography>
        <Typography variant="h4" sx={{ fontWeight: "bold", mt: 1 }}>
          {title}
        </Typography>
      </Box>

      <Card>
        <CardContent>
          <Typography variant="body1">{description}</Typography>
          <Chip label="Not built yet" size="small" sx={{ mt: 2 }} />
        </CardContent>
      </Card>
    </Box>
  );
}
